import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/components/Home';
import Register from '@/components/Register';
import RecoverPassword from '@/components/RecoverPassword';
import ChangePassword from '@/components/ChangePassword';

import Post from '@/components/Post';
import Profile from '@/components/Profile';

import Terms from '@/components/Terms';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
        },
        {
            path: '/register',
            name: 'Register',
            component: Register,
        },
        {
            path: '/glemtpassord',
            name: 'RecoverPassword',
            component: RecoverPassword,
        },
        {
            path: '/skriv',
            name: 'Post',
            component: Post,
        },
        {
            path: '/endrepassord',
            name: 'ChangePassword',
            component: ChangePassword,
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile,
        },
        {
            path: '/term',
            name: 'Terms',
            component: Terms,
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js